import DashboardPageContainer from "../components/DashboardPageContainer/DashboardPageContainer";
import FormFromJson from "../../../common/FormFromJson/FormFromJson";
import DashboardHeader from "../components/DashboardHeader/DashboardHeader";

const Profile = () => {
   return (
      <DashboardPageContainer>
         <DashboardHeader title={"Profile"} subtitle={""} />
         <FormFromJson jsonUrl="dashboard/profile" />
      </DashboardPageContainer>
   );
};

export default Profile;
